/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTicketTemplateDto } from '../../models/create-ticket-template-dto';
import { TicketTemplateDto } from '../../models/ticket-template-dto';

export interface TicketTemplateControllerCreate$Params {
  centerId: string;
      body: CreateTicketTemplateDto
}

export function ticketTemplateControllerCreate(http: HttpClient, rootUrl: string, params: TicketTemplateControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, ticketTemplateControllerCreate.PATH, 'post');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTemplateDto>;
    })
  );
}

ticketTemplateControllerCreate.PATH = '/api/ticket/{centerId}/template';
